import { Strategy } from '../types';
import { getStableId } from '../helpers/get-stable-id';
import { escapeIdForCss } from '../helpers/escape-id';

/**
 * Second strategy in the chain. Anchors on the element's `id` when the id is
 * "stable" — i.e., present, not suppressed via the explicit-tracking-attribute
 * empty-value mechanism, and not matching any autogenerated-id pattern.
 *
 * Returns `tag#id` (CSS-escaped) when the id is usable; null otherwise.
 *
 * Filtering is delegated to `getStableId` so this strategy and the
 * `fallback-css-path` walker (in the orchestration PR) share a single source
 * of truth for "is this id usable?"
 */
export const stableId: Strategy = {
  name: 'stableId',

  try(el, ctx) {
    const id = getStableId(el, ctx.config);
    if (id === null) {
      return null;
    }
    return `${el.tagName.toLowerCase()}#${escapeIdForCss(id)}`;
  },
};
